import { render, staticRenderFns } from "./mainGraph.vue?vue&type=template&id=3974d63f&scoped=true&"
import script from "./mainGraph.vue?vue&type=script&lang=js&"
export * from "./mainGraph.vue?vue&type=script&lang=js&"
import style0 from "./mainGraph.vue?vue&type=style&index=0&id=3974d63f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3974d63f",
  null
  
)

export default component.exports